var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuitcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0892 26.7617H3.91083C2.30724 26.7617 1 25.4545 1 23.8509V10.5309C1 8.92733 2.30724 7.62008 3.91083 7.62008H26.0892C27.6928 7.62008 29 8.92733 29 10.5309V23.8509C29 25.4545 27.6928 26.7617 26.0892 26.7617ZM3.91083 8.84206C2.97709 8.84206 2.21792 9.60125 2.21792 10.535V23.855C2.21792 24.7887 2.97709 25.5479 3.91083 25.5479H26.0892C27.0229 25.5479 27.7821 24.7887 27.7821 23.855V10.535C27.7821 9.60125 27.0229 8.84206 26.0892 8.84206H3.91083Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9978 18.5651H6.65509L1.27594 14.956L1.95797 13.9452L7.02858 17.3472H14.9978V18.5651Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0317 18.5651H14.6889V17.3472H22.6582L27.7288 13.9452L28.4108 14.956L23.0317 18.5651Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0824 14.6636H13.2934V15.8815H16.0824V14.6636Z",
    fill: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.515 6.7838V4.47784H9.43188V6.7838H8.21396V4.09625C8.21396 3.63344 8.59152 3.25586 9.05433 3.25586H20.8966C21.3594 3.25586 21.7369 3.63344 21.7369 4.09625V6.7838H20.515Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/suitcase.b5216ab33847dc6696545c64681730b1.svg";
export { ForwardRef as ReactComponent };